import React from 'react';

export type ButtonSize = 'sm' | 'md' | 'lg';
export type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger';

const SIZE_CLASSES: Record<ButtonSize, string> = {
    sm: 'h-7 px-2.5 text-xs gap-1.5',
    md: 'h-[34px] px-3.5 text-sm gap-1.5',
    lg: 'h-10 px-4 text-sm gap-2',
};

const VARIANT_CLASSES: Record<ButtonVariant, string> = {
    primary: 'bg-brand-600 text-brand-fg border border-transparent hover:bg-brand-700 disabled:hover:bg-brand-600',
    secondary: 'bg-surface-soft text-content border border-border hover:bg-surface',
    outline: 'bg-transparent text-content border border-border hover:bg-surface-soft',
    ghost: 'bg-transparent text-content-muted border border-transparent hover:bg-surface-soft hover:text-content',
    danger: 'bg-red-600 text-white border border-transparent hover:bg-red-700 disabled:hover:bg-red-600',
};

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    size?: ButtonSize;
    variant?: ButtonVariant;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({ size = 'md', variant = 'primary', className = '', disabled, ...props }, ref) => {
        return (
            <button
                ref={ref}
                disabled={disabled}
                className={[
                    'inline-flex items-center justify-center rounded-md font-semibold whitespace-nowrap transition-colors active:translate-y-px',
                    'disabled:opacity-50 disabled:cursor-not-allowed disabled:active:translate-y-0',
                    SIZE_CLASSES[size],
                    VARIANT_CLASSES[variant],
                    className,
                ].join(' ')}
                {...props}
            />
        );
    }
);
Button.displayName = 'Button';
